/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ActivityState {
  Completed = "completed",
  InProgress = "in_progress",
  Cancelled = "cancelled",
  Waiting = "waiting",
}

export function instanceOfActivityState(value: any): boolean {
  for (const key in ActivityState) {
    if (Object.prototype.hasOwnProperty.call(ActivityState, key)) {
      if (ActivityState[key as keyof typeof ActivityState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ActivityStateFromJSON(json: any): ActivityState {
  return ActivityStateFromJSONTyped(json, false);
}

export function ActivityStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityState {
  return json as ActivityState;
}

export function ActivityStateToJSON(value?: ActivityState | null): any {
  return value as any;
}

export function ActivityStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ActivityState {
  return value as ActivityState;
}
